module.exports = __webpack_public_path__ + "static/img/share.d29a492e.jpg";